import {
    ProductInDetailCurrencyHistoryType,
    ProductInDetailMapType,
    ProductInDetailSearchParamType,
    ProductInDetailType
} from "../interface";

export const productInDetailSearchParamInit: ProductInDetailSearchParamType = {
    newErpProductid: "",
    pageNo: 1,
    limit: 10
}

export const productInDetailCurrencyHistoryInit: ProductInDetailCurrencyHistoryType = {
    currency: "",
    erpProductCurrencyHistoryId: 0,
    index: 0,
    levelA: 0,
    levelB: 0,
    levelC: 0,
    levelD: 0,
    levelE: 0,
    pricingGroup: "",
    standard: ""
}

export const productInDetailInit: ProductInDetailType = {
    newErpProductid: "",
    newTxtNmItem: "",
    createdon: "",
    nameOfCreator: "",
    erpProductImageVO: {},
    vendor: "",
    category: "",
    newTxtStndItem: "",
    useFlag: "",
    newTxtCdItem: "",
    majorCategory: "",
    subCategory: "",
    productRange: "",
    productCurrencyHistoryResList: [],
    ptaItemName: "",
    newLProductGroupValue: "",
    productExplain: "",
    outFlag: "",
    newProductGroupid: ""
};

export const productInDetailMapInit: ProductInDetailMapType = {
    productDetailRes: productInDetailInit,
    totalCount: 0
}